<template>
  <div class="login-overlay" v-if="coverVisible" @click.self="close">
    <div class="login-modal">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="close">
        <svg viewBox="0 0 24 24" width="18" height="18">
          <path fill="#9ca3af" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>

      <h2 class="modal-title">登录</h2>

      <!-- 模式 tab -->
      <div class="login-tabs">
        <button
          class="tab-btn"
          :class="{ active: loginMode === 'code' }"
          @click="loginMode = 'code'"
        >验证码登录</button>
        <button
          class="tab-btn"
          :class="{ active: loginMode === 'password' }"
          @click="loginMode = 'password'"
        >账号密码登录</button>
      </div>

      <!-- 手机号输入 -->
      <div class="input-group">
        <div class="phone-input-wrap">
          <span class="country-code">+86</span>
          <div class="divider-v"></div>
          <input
            class="input-field phone-input"
            type="tel"
            v-model="phone"
            placeholder="请输入手机号"
            maxlength="11"
            @input="onPhoneInput"
          />
        </div>
      </div>

      <!-- 验证码输入 -->
      <div class="input-group" v-if="loginMode === 'code'">
        <div class="code-input-wrap">
          <input
            class="input-field code-input"
            type="text"
            v-model="code"
            placeholder="请输入验证码"
            maxlength="6"
          />
          <button
            class="send-code-btn"
            :class="{ disabled: !canSend }"
            :disabled="!canSend"
            @click="sendCode"
          >{{ sendBtnText }}</button>
        </div>
      </div>

      <!-- 密码输入 -->
      <div class="input-group" v-if="loginMode === 'password'">
        <div class="phone-input-wrap">
          <input
            class="input-field phone-input"
            type="password"
            v-model="password"
            placeholder="请输入登录密码"
            maxlength="32"
            autocomplete="current-password"
          />
        </div>
      </div>

      <!-- 登录按钮 -->
      <button
        class="login-btn"
        :class="{ active: canLogin }"
        @click="handleLogin"
      >登录</button>

      <!-- 协议 -->
      <div class="agreement-row" @click="agreed = !agreed">
        <div class="checkbox" :class="{ checked: agreed }">
          <svg v-if="agreed" viewBox="0 0 24 24" width="12" height="12">
            <path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
        </div>
        <span class="agreement-text" @click.stop>
          已阅读同意
          <a target="_blank" href="https://docs.qq.com/doc/p/d6f66816f9d7b7c6d7d0b41cbe9f0f9d7864032c" class="link">《模型服务协议》</a>
          和
          <a target="_blank" href="https://docs.qq.com/doc/p/5824fed40983926f903df414cfb36b6d68c38b4c" class="link">《用户隐私协议》</a>
        </span>
      </div>

      <!-- 底部反馈 -->
      <!-- <div class="footer-row">
        <span class="footer-text">遇到问题？</span>
        <a href="javascript:;" class="link">去反馈</a>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoginPanel',
  data() {
    return {
      coverVisible: false,
      loginMode: 'code',
      phone: '',
      code: '',
      password: '',
      agreed: false,
      countdown: 0,
      timer: null,
      sending: false,
      logging: false,
    };
  },
  computed: {
    phoneValid() {
      return /^1[3-9]\d{9}$/.test(this.phone);
    },
    canSend() {
      return this.phoneValid && this.countdown === 0 && !this.sending;
    },
    canLogin() {
      if (this.loginMode === 'password') {
        return this.phoneValid && this.password.length >= 6 && this.agreed;
      }
      return this.phoneValid && this.code.length === 6 && this.agreed;
    },
    sendBtnText() {
      if (this.sending) return '发送中...';
      return this.countdown > 0 ? `${this.countdown}s 后重发` : '发送验证码';
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    show() {
      this.coverVisible = true;
      this.phone = '';
      this.code = '';
      this.password = '';
      this.agreed = false;
      this.countdown = 0;
      this.sending = false;
      this.logging = false;
    },
    close() {
      this.coverVisible = false;
    },
    onPhoneInput() {
      this.phone = this.phone.replace(/\D/g, '').slice(0, 11);
    },
    sendCode() {
      if (!this.canSend) return;
      this.sending = true;
      this.$http.post('/front/auth/smscode/', { phone: this.phone, sms_code: 'SMS_507325270' })
        .then(res => {
          // 接口约定 code===0 或 code===200 为成功，兼容两种
          const ok = res && (res.code === 0 || res.code === 200 || res.status === 200);
          if (ok) {
            this.$toast && this.$toast('验证码已发送');
            this.countdown = 60;
            this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.timer);
                this.timer = null;
                this.countdown = 0;
              }
            }, 1000);
          } else {
            const msg = (res && (res.msg || res.message)) || '发送失败，请稍后重试';
            this.$toast && this.$toast(msg);
          }
        })
        .catch(() => {
          this.$toast && this.$toast('网络异常，请稍后重试');
        })
        .finally(() => {
          this.sending = false;
        });
    },
    handleLogin() {
      if (!this.phoneValid) {
        this.$toast && this.$toast('请输入正确的手机号');
        return;
      }
      if (this.loginMode === 'code' && this.code.length !== 6) {
        this.$toast && this.$toast('请输入6位验证码');
        return;
      }
      if (this.loginMode === 'password' && this.password.length < 6) {
        this.$toast && this.$toast('请输入登录密码');
        return;
      }
      if (!this.agreed) {
        this.$toast && this.$toast('请先同意服务协议和隐私协议');
        return;
      }
      if (this.logging) return;
      this.logging = true;

      const isPassword = this.loginMode === 'password';
      const url = isPassword ? '/front/auth/login/phone/' : '/front/auth/login/code/';
      const payload = isPassword
        ? { phone: this.phone, password: this.password }
        : { phone: this.phone, code: Number(this.code) };

      this.$http.post(url, payload)
        .then(res => {
          const ok = res && (res.code === 0 || res.code === 200 || res.status === 200);
          if (ok) {
            const token = res.data && (res.data.token || res.data.access);
            if (token) localStorage.setItem('token', token);
            this.$toast && this.$toast('登录成功');
            this.close();
            location.reload();
          } else {
            const msg = (res && (res.msg || res.message)) || '登录失败，请稍后重试';
            this.$toast && this.$toast(msg);
          }
        })
        .catch(() => {
          this.$toast && this.$toast('网络异常，请稍后重试');
        })
        .finally(() => {
          this.logging = false;
        });
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.login-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-modal {
  position: relative;
  width: 420px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 40px 32px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);

  .close-btn {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: background 0.15s;

    &:hover { background: #f3f4f6; }
  }

  .modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 20px;
    text-align: center;
  }

  .login-tabs {
    display: flex;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 20px;

    .tab-btn {
      flex: 1;
      height: 38px;
      border: none;
      background: transparent;
      font-size: 14px;
      color: #6b7280;
      cursor: pointer;
      font-family: inherit;
      border-bottom: 2px solid transparent;
      margin-bottom: -1px;
      transition: color 0.15s, border-color 0.15s;

      &:hover { color: #2563eb; }

      &.active {
        color: #2563eb;
        font-weight: 600;
        border-bottom-color: #2563eb;
      }
    }
  }

  .input-group {
    margin-bottom: 14px;
  }

  /* 手机号输入框 */
  .phone-input-wrap {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.15s;

    &:focus-within { border-color: #2563eb; }

    .country-code {
      flex-shrink: 0;
      padding: 0 12px;
      font-size: 14px;
      color: #374151;
      white-space: nowrap;
    }

    .divider-v {
      width: 1px;
      height: 20px;
      background: #d1d5db;
      flex-shrink: 0;
    }

    .phone-input {
      border: none;
      outline: none;
      flex: 1;
      padding: 12px 14px;
      font-size: 14px;
      color: #111827;
      background: transparent;
      font-family: inherit;
      box-sizing: border-box;

      &::placeholder { color: #9ca3af; }
    }
  }

  /* 验证码输入框 */
  .code-input-wrap {
    display: flex;
    align-items: stretch;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.15s;

    &:focus-within { border-color: #2563eb; }

    .code-input {
      flex: 1;
      border: none;
      outline: none;
      padding: 12px 14px;
      font-size: 14px;
      color: #111827;
      background: transparent;
      font-family: inherit;
      box-sizing: border-box;

      &::placeholder { color: #9ca3af; }
    }

    .send-code-btn {
      flex-shrink: 0;
      border: none;
      border-left: 1px solid #d1d5db;
      padding: 0 16px;
      font-size: 13px;
      color: #2563eb;
      background: transparent;
      cursor: pointer;
      white-space: nowrap;
      font-family: inherit;
      transition: background 0.15s, color 0.15s;

      &:hover:not(.disabled) { background: #eff6ff; }

      &.disabled {
        color: #9ca3af;
        cursor: not-allowed;
      }
    }
  }

  /* 登录按钮 */
  .login-btn {
    display: block;
    width: 100%;
    height: 46px;
    margin-top: 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #93c5fd;
    cursor: not-allowed;
    transition: background 0.2s;
    letter-spacing: 0.04em;
    font-family: inherit;

    &.active {
      background: #2563eb;
      cursor: pointer;

      &:hover { background: #1d4ed8; }
    }
  }

  /* 协议 */
  .agreement-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 18px;
    cursor: pointer;
    user-select: none;

    .checkbox {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      border: 1.5px solid #d1d5db;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.15s;
      background: #fff;
      margin-top: 1px;

      &.checked {
        border-color: #2563eb;
        background: #2563eb;
      }
    }

    .agreement-text {
      font-size: 12px;
      color: #6b7280;
      line-height: 1.6;

      .link {
        color: black;
        text-decoration: none;

        &:hover { text-decoration: underline; }
      }
    }
  }

  /* 底部反馈 */
  .footer-row {
    text-align: center;
    margin-top: 16px;

    .footer-text {
      font-size: 13px;
      color: #9ca3af;
    }

    .link {
      font-size: 13px;
      color: #2563eb;
      text-decoration: none;

      &:hover { text-decoration: underline; }
    }
  }
}
</style>